import { render } from "./BookingPassengers.vue?vue&type=template&id=2344940e&scoped=true&lang=pug"
import script from "./BookingPassengers.vue?vue&type=script&lang=ts"
export * from "./BookingPassengers.vue?vue&type=script&lang=ts"

import "./BookingPassengers.vue?vue&type=style&index=0&id=2344940e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2344940e"

export default script